











import { Component, Mixins, Prop } from "vue-property-decorator";
import { RawLocation, Route } from "vue-router";
import { DomainRegistry } from "../../domain";
import { UnmanagedLoginView } from "../authentication";

@Component({
  components: {
    UnmanagedLoginView,
  },
})
export default class GuestWizardNewLinkedDocumentEditView extends Mixins() {
  @Prop()
  userCode: string;

  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  shouldAuthenticateLater: boolean;

  @Prop()
  patientNo: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  shouldSelectDepartment: boolean;

  async beforeEnter(to: Route): Promise<RawLocation> {
    if (to.query.receptionId || to.query.receptionDetailId) {
      // 暫定対応。将来的にはWF用にdispatchする。
      return {
        path: "/Error",
        query: {
          url: to.fullPath,
          message: "ワークフロー文書のため編集できません。",
        }
      };
    }
    const isOk = await this.isNewLinkedDocumentCreatable(this.systemKey, this.linkKey, this.patientNo, this.shouldValidateExistingLinkedDocument);
    return isOk
      ? {
        path: "/Wizard/Guest/EditNewDocument",
        replace: true,
        query: {
          patientNo: to.query.patientNo,
          formatId: to.query.formatId,
          chainedFormatId: to.query.chainedFormatId,
          chainedFormatIds: to.query.chainedFormatIds,
          institutionNo: to.query.institutionNo,
          regionalInstitutionNo: to.query.regionalInstitutionNo,
          hisInfoGetterParameter: to.query.hisInfoGetterParameter,
          systemKey: to.query.systemKey,
          linkKey: to.query.linkKey,
          orderNo: to.query.linkKey,
          shouldValidateExistingLinkedDocument: to.query.shouldValidateExistingLinkedDocument,
          registeredMessage: to.query.registeredMessage,
        },
      }
      : {
        path: "/Warning",
        query: {
          url: to.fullPath,
          message: "指定されたキー(" + this.systemKey + ", " + this.linkKey + ")に紐づけられた文書が既に存在します.",
        }
      };
  }

  private async isNewLinkedDocumentCreatable(systemKey: string, linkKey: string, patientNo: string, shouldValidateExistingLinkedDocument: boolean): Promise<boolean> {
    if (!shouldValidateExistingLinkedDocument) { return true; }
    const id = await this.getLinkedDocumentId(systemKey, linkKey, patientNo);
    return (id == null);
  }

  private async getLinkedDocumentId(systemKey: string, linkKey: string, patientNo: string): Promise<number> {
    const repository = DomainRegistry.collaboration.getLinkedDocumentRepository();
    return repository.getDocumentId(systemKey, linkKey, patientNo);
  }
}
